import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Navbar from './components/layout/Navbar';
import Footer from './components/layout/Footer';
import WhatsAppButton from './components/WhatsAppButton';
import { Helmet } from 'react-helmet';
import styled, { createGlobalStyle } from 'styled-components';
import { theme } from './styles/theme';

// Import page components
import HomePage from './components/pages/Home';
import AboutPage from './components/About';
import ServicesPage from './components/Services';
import SolutionsPage from './components/pages/Solutions';
import ProductsPage from './components/pages/Products';
import InvestmentsPage from './components/pages/Investments';
import PartnersPage from './components/Partners';
import BlogPage from './components/pages/Blog';
import BlogPostPage from './components/pages/BlogPost';
import SA1stWorkersLandingPage from './components/pages/SA1stWorkersLanding';
import ContactPage from './components/Contact';
import TestMotion from './components/TestMotion';

// Import service pages
import WebsiteCreationPretoria from './components/services/WebsiteCreationPretoria';
import AppDevelopmentSouthAfrica from './components/services/AppDevelopmentSouthAfrica';
import SoftwareDevelopment from './components/services/SoftwareDevelopment';
import DataDevelopment from './components/services/DataDevelopment';
import PretoriaWebDesign from './components/services/PretoriaWebDesign';

const GlobalStyle = createGlobalStyle`
  body {
    margin: 0;
    padding: 0;
    background-color: ${theme.colors.primary};
    color: ${theme.colors.text.primary};
    font-family: ${theme.fonts.primary};
  }
  
  a {
    text-decoration: none;
  }
  
  * {
    box-sizing: border-box;
  }
`;

const AppContainer = styled.div`
  background-color: ${theme.colors.primary};
  color: ${theme.colors.text.primary};
`;

function App() {
  return (
    <Router>
      <GlobalStyle />
      <AppContainer>
        <Helmet>
          <script type="application/ld+json">
            {`
              {
                "@context": "https://schema.org",
                "@type": "LocalBusiness",
                "name": "Afrotech Group",
                "description": "Professional website creation, app development, and software development services in Pretoria, South Africa",
                "url": "https://www.afrotechgroup.co.za",
                "address": {
                  "@type": "PostalAddress",
                  "addressLocality": "Pretoria",
                  "addressRegion": "Gauteng",
                  "addressCountry": "South Africa"
                },
                "geo": {
                  "@type": "GeoCoordinates",
                  "latitude": "-25.7479",
                  "longitude": "28.2293"
                },
                "sameAs": [
                  "https://www.facebook.com/afrotechgroup",
                  "https://www.linkedin.com/company/afrotech-group"
                ]
              }
            `}
          </script>
        </Helmet>
        <Navbar />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/solutions" element={<SolutionsPage />} />
          <Route path="/products" element={<ProductsPage />} />
          <Route path="/partners" element={<PartnersPage />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/blog/:id" element={<BlogPostPage />} />
          <Route path="/safirst" element={<SA1stWorkersLandingPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/investments" element={<InvestmentsPage />} />
          
          {/* Service Pages */}
          <Route path="/services/website-creation-pretoria" element={<WebsiteCreationPretoria />} />
          <Route path="/services/app-development-south-africa" element={<AppDevelopmentSouthAfrica />} />
          <Route path="/services/software-development" element={<SoftwareDevelopment />} />
          <Route path="/services/data-development" element={<DataDevelopment />} />
          <Route path="/pretoria-web-design" element={<PretoriaWebDesign />} />
          <Route path="/test-motion" element={<TestMotion />} />
        </Routes>
        <Footer />
        <WhatsAppButton />
      </AppContainer>
    </Router>
  );
}

export default App;
